window.jRespond = window.jRespond || require('jRespond');
var Navigation = {};

(function ($) {
    'use strict';

    Navigation = function () {

        var self = {}, __self = {};

        self.init = function () {

            // DOM Elements
            __self.$body = $('body');
            __self.$app = $('#app');
            __self.$mobileMenuTrigger = $('.mobile-menu-trigger');
            __self.$mobileMenuWrapper = $('.-mobile-wrapper');
            __self.$mobileMenu = $('.mobile-menu');
            __self.$mobileMenuTraverse = $('.-menu-traverse');
            __self.$accordionNav = $('.-vertical-accordion-menu');
            __self.$accordionToggle = $('.-vertical-accordion-menu .-accordion-toggle');

            // jRespond Settings
            __self.jRes = jRespond([
            {
                label: 'mobile',
                enter: 0,
                exit: 999
            },{
                label: 'desktop',
                enter: 1000,
                exit: 10000
            }
            ]);

            // jRespond Behavior
            __self.jRes.addFunc([
            {
                breakpoint: ['mobile'],
                enter: function() {
                    __self.breakpoint = 'mobile';
                    __self.$mobileMenuWrapper.addClass('-active');
                    self.mobileMenuInit();
                },
                exit: function() {
                    self.mobileMenuUninit();
                }
            },
            {
                breakpoint: ['desktop'],
                enter: function() {
                    __self.breakpoint = 'desktop';
                    __self.$body.removeClass('-menu-open');
                    __self.$mobileMenuWrapper.removeClass('-active');
                    __self.$mobileMenuWrapper.removeClass('-primary-nav-open');
                },
                exit: function() {
                }
            }
            ]);

            // Module Init
            self.navigationInit();
        };

        self.navigationInit = function () {

            // On Load

            // Events
            __self.$mobileMenuTrigger.on('click', self.mobileMenuTrigger);
            __self.$accordionToggle.on('click', self.accordionToggle);
            __self.$mobileMenuTraverse.on('click', self.mobileMenuTraverse);

        };

        self.mobileMenuInit = function() {
            __self.$mobileMenu.show();
            __self.$mobileMenu.css('z-index', '500');
        };

        self.mobileMenuUninit = function() {
            __self.$mobileMenu.hide();
            __self.$mobileMenu.css('z-index', '0');
        };

        self.mobileMenuTrigger = function(event) {
            event.preventDefault();
            __self.$body.toggleClass('-primary-nav-open');
            __self.$mobileMenuWrapper.toggleClass('-menu-open');
        };

        self.mobileMenuTraverse = function(event) {
            event.preventDefault();
            $(this).closest('.-menu-layer').removeClass('-active-layer');
            var target = '#' + $(this).data('target');
            setTimeout(function() {
                $(target).addClass('-active-layer');
            }, 200);

        };

        self.accordionToggle = function(e) {
            var trigger = $(this);
            if(trigger.parent().hasClass('-accordion-active')) {
                // Reset all nested accordions
                trigger.parent().find('.-accordion-active').children('.-sub-menu').slideToggle();
                trigger.parent().find('.-accordion-active').find('.-indicator').toggleClass('-open');

                // Reset currently active accordion
                trigger.next('.-sub-menu').slideToggle();
                trigger.parent().toggleClass('-accordion-active');
                trigger.find('.-indicator').toggleClass('-open');

                trigger.parent().find('.-accordion-active').removeClass('-accordion-active');
            } else {
                // Trigger selected accordion
                trigger.next('.-sub-menu').slideToggle();
                trigger.parent().toggleClass('-accordion-active');
                trigger.find('.-indicator').toggleClass('-open');
            }
        };

        self.resize = function() {};

        self.init();
        return self;
    };

}(window.jQuery));

module.exports = Navigation;
